const setModal = modal => ({
  type: "SET_MODAL",
  modal,
});

export default setModal;
